/**
 * TanStack Query hooks for `pinterest-ads-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	pinterestAdsIntegrationQueryKeys,
	type CreatePinterestAdsIntegrationBody,
	type ListPinterestAdsIntegrationResponse,
	type PinterestAdsIntegrationRow,
} from "./api";

export function usePinterestAdsIntegrationList(): UseQueryResult<ListPinterestAdsIntegrationResponse, Error> {
	return useQuery({
		queryKey: pinterestAdsIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function usePinterestAdsIntegrationCreate(): UseMutationResult<PinterestAdsIntegrationRow, Error, CreatePinterestAdsIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pinterestAdsIntegrationQueryKeys.all });
		},
	});
}

export function usePinterestAdsIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pinterestAdsIntegrationQueryKeys.all });
		},
	});
}
